import vSelect from "vue-select";

function setupComponent (Vue) {
    Vue.component("v-select", vSelect);
};

export default setupComponent;
